import React from "react";
import CreateEvent from "../../components/Shop/CreateEvent";
import DashboardSideBar from "../../components/Shop/Layout/DashboardSideBar";

const ShopCreateEvents = () => {
  return (
    <div className="min-h-screen bg-secondary-50">
      <DashboardSideBar active={6} />
      <div className="lg:ml-64 pt-16 lg:pt-0 min-h-screen">
        <div className="p-4 sm:p-6 lg:p-8">
          <CreateEvent />
        </div>
      </div>
    </div>
  );
};

export default ShopCreateEvents;


